export default defineNuxtPlugin(() => {
    // init Fingerprint.js and Snowplow (on prod)
    useVisitorStore().initializeFingerprintAndSnowplow()
})
